import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DAY_IDX = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const TZ = "Asia/Jakarta";

function nowInWib() {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const wd = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  return { day: DAY_IDX[wd], minutes: (Number(get("hour")) % 24) * 60 + Number(get("minute")) };
}

export function todayName() {
  return nowInWib().day;
}

export function fmtTime(t) {
  return (t || "").replace(":", ".");
}

export function isOpenNow(hours) {
  const { day, minutes } = nowInWib();
  const today = hours?.find((h) => h.day === day);
  if (!today || today.closed) return { open: false, today };
  const [oh, om] = today.open.split(":").map(Number);
  const [ch, cm] = today.close.split(":").map(Number);
  return { open: minutes >= oh * 60 + om && minutes < ch * 60 + cm, today };
}

export function useStoreConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);
  return config;
}
